import { z } from "zod/v4";

export const experienceTitleSchema = z.string().trim().min(1, { message: "experience.title.input.error" });

// Kept for future use
// import {
//   TITLE_MAX_CHARACTERS,
//   TITLE_MAX_CHARACTERS_ERROR_KEY,
// } from "@/features/experience-shared/constants/experience-fields-limits";
//
// export const experienceTitleSchema = z
//   .string()
//   .trim()
//   .min(1, { message: "experience.title.input.error" })
//   .max(TITLE_MAX_CHARACTERS, { message: TITLE_MAX_CHARACTERS_ERROR_KEY });
